import { render, staticRenderFns } from "./FieldLabel.vue?vue&type=template&id=beb456aa&scoped=true"
import script from "./FieldLabel.vue?vue&type=script&lang=js"
export * from "./FieldLabel.vue?vue&type=script&lang=js"
import style0 from "./FieldLabel.vue?vue&type=style&index=0&id=beb456aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb456aa",
  null
  
)

export default component.exports